import moment from "moment";
const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";
export const dateValueToLegacyDateString = (date) => moment(date).format(DEFAULT_DATE_FORMAT);
